module.exports = __webpack_public_path__ + "static/twitter-new-242685bd5342ab07ee85fc5d94a12f03.png";